import { FETCH_VIRTUAL_VISIT_REQUESTS, UPDATE_VIRTUAL_VISIT_REQUEST_STATUS } from "../actions";
const initialState = {
  virtualVisitRequestsError: null,
  virtualVisitRequests: [],
  virtualVisitRequestStatusUpdated: "",
  virtualVisitRequestStatusUpdateError: null,
};

function virtualVisitRequestReducer(state = initialState, action) {
  let virtualVisitRequests;
  let virtualVisitRequestStatusUpdated;

  switch (action.type) {
    case `${FETCH_VIRTUAL_VISIT_REQUESTS}_PENDING`:
      return { ...state, loading: true };
    case `${UPDATE_VIRTUAL_VISIT_REQUEST_STATUS}_PENDING`:
      return { ...state, loading: true };

    case `${FETCH_VIRTUAL_VISIT_REQUESTS}_FULFILLED`:
      virtualVisitRequests = action.payload.data;
      return { ...state, loading: false, virtualVisitRequests };
    case `${UPDATE_VIRTUAL_VISIT_REQUEST_STATUS}_FULFILLED`:
      virtualVisitRequestStatusUpdated = action.payload.data;
      return { ...state, loading: false, virtualVisitRequestStatusUpdated };

    case `${FETCH_VIRTUAL_VISIT_REQUESTS}_REJECTED`:
      return {
        ...state,
        loading: false,
        virtualVisitRequestsError: `${action.payload.message}`,
        state: initialState,
      };
    case `${UPDATE_VIRTUAL_VISIT_REQUEST_STATUS}_REJECTED`:
      return {
        ...state,
        loading: false,
        virtualVisitRequestStatusUpdateError: `${action.payload.message}`,
        state: initialState,
      };

    default:
      return state;
  }
}

export default virtualVisitRequestReducer;
